import { BLOCKS } from '@contentful/rich-text-types';
import { FC } from 'react';
import cn from 'classnames';

import { DataLink, CommonRichText as Content } from 'components/Shared/SharedComponents';
import type { RichTextParsersConfig } from 'types/objectTypes';
import { mapBlocksSpan } from 'lib/richTextMappers';

import styles from './ContentWithSubBlocks.module.scss';

import type { ICommonView, ITitle } from '../config/declarations';

const parsersConfigContent: RichTextParsersConfig = {
  [BLOCKS.HEADING_1]: {
    mapper: mapBlocksSpan,
    classNames: cn(styles.title, styles.titleH1),
  },
  [BLOCKS.HEADING_2]: {
    mapper: mapBlocksSpan,
    classNames: cn(styles.title, styles.titleH2),
  },
  [BLOCKS.HEADING_3]: {
    mapper: mapBlocksSpan,
    classNames: cn(styles.title, styles.titleH3),
  },
  [BLOCKS.PARAGRAPH]: {
    classNames: styles.paragraph,
  },
};

const parsersConfigTitle: RichTextParsersConfig = {
  [BLOCKS.PARAGRAPH]: {
    classNames: styles.commonTitle,
  },
};

export const CommonView: FC<ICommonView> = ({ block }) => {
  const { link, content } = block;

  return (
    <div className={styles.statistics}>
      <Content content={content} parsersConfig={parsersConfigContent} />
      {link && (
        <DataLink link={link} className={styles.button}>
          {link.title}
        </DataLink>
      )}
    </div>
  );
};

export const CommonTitle: FC<ITitle> = ({ content }) => (
  <Content
    content={content}
    parsersConfig={parsersConfigTitle}
  />
);
